<template>
  <div class="radio-group" :class="{ inline }">
    <div
      v-for="(option, index) in normalizedOptions"
      :key="index"
      class="d-flex align-items-center"
    >
      <input
        class="custom-radio"
        type="radio"
        :id="`${name}-${index}`"
        :name="name"
        :value="option.value"
        :checked="modelValue === option.value"
        :disabled="option.disabled"
        :class="{ disabled: option.disabled }"
        @change="updateValue(option.value)"
      />
      <label :class="{ disabled: option.disabled }" class="form-check-label custom-label" :for="`${name}-${index}`">
        {{ option.label }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: null, // 当前选中的值
    },
    options: {
      type: [Array, Object], // 支持单个选项（Object）或多个选项（Array）
      required: true,
      validator: (opts) => {
        if (Array.isArray(opts)) {
          return opts.every(
            (opt) =>
              typeof opt === "object" &&
              "value" in opt &&
              "label" in opt
          );
        }
        if (typeof opts === "object") {
          return "value" in opts && "label" in opts;
        }
        return false;
      },
    },
    name: {
      type: String,
      required: true, // 必须提供 name 属性
    },
    inline: {
      type: Boolean,
      default: false, // 是否显示为横排样式
    },
  },
  computed: {
    modelValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    normalizedOptions() {
      // 将单个选项对象转换为数组，保持一致性
      return Array.isArray(this.options) ? this.options : [this.options];
    },
  },
  methods: {
    updateValue(value) {
      this.modelValue = value;
    },
  },
};
</script>

<style scoped>
.radio-group.inline {
  display: flex;
  align-items: center;
  gap: 16px;
}

/* 调整 radio 的尺寸 */
.custom-radio {
  width: 20px;
  height: 20px;
  cursor: pointer;
  border-radius: 50%; /* 圆形样式 */
  border: 2px solid #2443ac; /* 默认边框颜色 */
  appearance: none; /* 移除默认样式 */
  outline: none;
  transition: background-color 0.2s ease, border-color 0.2s ease;
  position: relative;
}

/* 未选中状态 */
.custom-radio:not(:checked) {
  background-color: #ffffff; /* 未选中背景为白色 */
}

/* 选中状态 */
.custom-radio:checked {
  background-color: #2443ac; /* 选中背景颜色 */
  border-color: #2443ac; /* 选中边框颜色 */
  box-shadow: 0 0 0 0.2rem rgba(36, 67, 172, 0.25); /* 外环效果 */
}

/* 选中状态中间的白色圆点 */
.custom-radio:checked::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 8px; /* 中间圆点的宽度 */
  height: 8px; /* 中间圆点的高度 */
  background-color: #ffffff; /* 中间圆点的颜色 */
  border-radius: 50%; /* 圆形样式 */
}

/* 禁用状态 */
.custom-radio:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

/* 鼠标悬停效果 */
.custom-radio:hover:not(:disabled) {
  box-shadow: 0 0 0 0.15rem rgba(36, 67, 172, 0.15);
}

/* 调整文字样式 */
.custom-label {
  padding-left: 8px;
  font-size: 1rem;
  cursor: pointer;
}
</style>
